import React from "react";
import PropTypes from "prop-types";
import APIConfig from "../../../../../api/APIConfig";
import AuthAPI from "../../../../../api/AuthAPI";

export default class TaskDashboardTab extends React.Component {
    constructor(props) {
        super(props);
        this.containerStyle = {
            flex: "1 1 auto",
            minHeight: 0
        };
        this.iframeStyle = {
            width: "100%",
            height: "100%",
            display: "block",
            border: 0
        };
    }

    getDashboardUrl = _ => {
        const token = encodeURIComponent(AuthAPI.getUserAccessToken() || "");
        return `${APIConfig.url("/modulo-task/tasks/dashboard")}?token=${token}`;
    }

    render() {
        return (
            <div
                className={this.props.active ? "" : "d-none"}
                style={this.containerStyle}
            >
                <iframe
                    title={"Task"}
                    src={this.getDashboardUrl()}
                    style={this.iframeStyle}
                />
            </div>
        );
    }
}

TaskDashboardTab.propTypes = {
    active: PropTypes.bool
};
